<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <loading :active='isLoading' :is-full-page="fullPage" :loader='loader' />
            <div class="container h-100">
                <router-link class="navbar-brand" to="/"><img v-bind:src="imagePath + siteDatas.siteCMS.header_logo"></router-link>
                <div class="collapse navbar-collapse h-100" id="navbarNav">
                    <ul class="navbar-nav h-100 align-items-center">
                        <li class="nav-item trade-in">
                            <router-link class="nav-link" to="/sell-device">Start Selling</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" to="/sell-in-bulk">Sell In Bulk</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" to="/buy-device">Buy Certified Used</router-link>
                        </li>
                    </ul>
                    <ul class="navbar-nav ml-auto h-100 align-items-center">
                        <li class="nav-item">
                            <router-link class="nav-link" to="/support">Support</router-link>
                        </li>
                        <li class="nav-item cart">
                            <router-link class="nav-link cart-link" to="/cart">
                                <div class="box">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 34 34">
                                        <path d="M24 3l-.743 2h-1.929l-3.474 12h-13.239l-4.615-11h16.812l-.564 2h-13.24l2.937 7h10.428l3.432-12h4.195zm-15.5 15c-.828 0-1.5.672-1.5 1.5 0 .829.672 1.5 1.5 1.5s1.5-.671 1.5-1.5c0-.828-.672-1.5-1.5-1.5zm6.9-7-1.9 7c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5 1.5-.671 1.5-1.5c0-.828-.672-1.5-1.5-1.5z"/>
                                    </svg>
                                </div>
                                My Cart ( {{ ( myPurchaseCarts - 0 ) + ( mySellCarts - 0 ) }} )
                            </router-link>
                        </li>
                        
                        <li  v-if="token || menuAuthenticateds == true" class="nav-item position-relative custom-dropdown">
                            <a class="nav-link" href="#"><i class="fa fa-user mr-2"></i>My Account</a>
                            <ul class="custom-dropdown-menu">
                                <li> <router-link class="dropdown-item" to="/user/dashboard"><i class="fas fa-tachometer-alt mr-2"></i>Dashboard</router-link></li>
                                <li> <a class="dropdown-item" href="javascript:void(0)" v-on:click="logout"><i class="fas fa-sign-out-alt mr-2"></i>Logout</a></li>
                            </ul>
                        </li>
                        <li v-else class="nav-item">
                            <router-link class="nav-link" to="/login">Login</router-link>
                        </li>
                    </ul>
                </div>
                <div class="w-100 text-right only-mobile-view">
                    <button class="navbar_toggler_btn" type="button" @click="openSideDrawer()">
                        <i class="fas fa-bars"></i>
                    </button>
                </div>
            </div>
        </nav>

        <!--mobile sidebar-->
        <div id="mobile_sidebar">
            <nav class="sidebar">
                <ul class="nav flex-column" id="">
                    <li class="nav-item sidebar_item" @click="closeSideDrawer()">
                        <router-link class="nav-link" to="/sell-device"><i class="fas fa-cart-arrow-down mr-2"></i> Start Selling</router-link>
                    </li>
                    <li class="nav-item sidebar_item" @click="closeSideDrawer()">
                        <router-link class="nav-link" to="/sell-in-bulk"><i class="fas fa-shopping-basket mr-2"></i> Sell In Bulk</router-link>
                    </li>
                    <li class="nav-item sidebar_item" @click="closeSideDrawer()">
                        <router-link class="nav-link" to="/buy-device"><i class="fas fa-mobile-alt mr-2"></i> Buy Certified Used</router-link>
                    </li>
                    <li class="nav-item sidebar_item" @click="closeSideDrawer()">
                        <router-link class="nav-link" to="/support"><i class="fas fa-phone-volume mr-2"></i> Support</router-link>
                    </li>
                    
                    <li  v-if="token || menuAuthenticateds == true" class="nav-item sidebar_item" @click="closeSideDrawer()">
                        <router-link class="nav-link" to="/user/dashboard"><i class="fas fa-tachometer-alt mr-2"></i>My Dashboard</router-link>
                    </li>
                    <li class="nav-item cart sidebar_item" @click="closeSideDrawer()">
                        <router-link class="nav-link cart-link" to="/cart">
                           <i class="fas fa-shopping-cart mr-2"></i> My Cart ( {{ ( myPurchaseCarts - 0 ) + ( mySellCarts - 0 ) }} )
                        </router-link>
                    </li>
                    <li  v-if="token || menuAuthenticateds == true" class="nav-item sidebar_item" @click="closeSideDrawer()">
                        <a class="nav-link" href="javascript:void(0)" v-on:click="logout"><i class="fas fa-sign-out-alt mr-2"></i> Logout</a>
                    </li>
                    <li class="nav-item sidebar_item"  @click="closeSideDrawer()" v-else >
                            <router-link class="nav-link sidebar_link" to="/login"><i class="fas fa-sign-out-alt mr-2"></i>Login</router-link>
                    </li>
                </ul>
            </nav>
        </div>
        <div id="side-drawer-void" class="position-fixed d-none" @click="closeSideDrawer()"></div>

        

        
    </div>
    
</template>

<script>
import $ from "jquery";
import Loading from "vue-loading-overlay";

export default {
    name: "SiteHeader",
    components: {
        Loading
    },
    props: ['mySellCarts', 'myPurchaseCarts', 'menuAuthenticateds', 'siteDatas'],
    data() {
        return {
            isLoading: false,
            fullPage: true,
            loader: "bars",
            token: localStorage.getItem("_token"),
            data: [],
            imagePath: this.$api + "upload/header_logo/"
        } 
    },
    created() {
        //this.getHeaderData();
    },
    methods: {
        logout: function() {
            localStorage.clear();
            this.$router.push("/login")
        },
        openSideDrawer: function() {
            $("#mobile_sidebar").show();
            $("#side-drawer-void").addClass('d-block');
            $("#side-drawer-void").removeClass('d-none');
            // document.getElementById("mobile_sidebar").style.right = "0";
            // //document.getElementById("mobile_sidebar").style.transition = "1s";
            // document.getElementById("side-drawer-void").classList.add("d-block");
            // document.getElementById("side-drawer-void").classList.remove("d-none");
        },
        closeSideDrawer:function() {
            
            // document.getElementById("mobile_sidebar").style.right = "-100%";
            // // document.getElementById("mobile_sidebar").style.transition = "2s";
            // document.getElementById("side-drawer-void").classList.add("d-none");
            // document.getElementById("side-drawer-void").classList.remove("d-block");
            $("#mobile_sidebar").hide();
            $("#side-drawer-void").addClass('d-none');
            $("#side-drawer-void").removeClass('d-block');
        }
        // getHeaderData: function() {
        //     this.isLoading = true;
        //     var config = {
        //         method: "GET",
        //         url: this.$api + "api/geek-site"
        //     };
        //     this.$axios(config).then((response) => {
        //         if(response.data.status == "success") {
        //             this.data = response.data.data;
        //         }
        //         this.isLoading = false;
        //     }).catch(error => {
        //         console.log(error);
        //         this.isLoading = false;
        //     });
        // }
    }
}
</script>

<style scoped>
.custom-dropdown-menu {
    list-style: none;
    position: absolute;
    top: 100%;
    right: 0;
    background-color: white;
    width: 152px;
    display: none;
    border-top: 2px solid #fed136;
    border-bottom: 2px solid #fed136;
}

.custom-dropdown:hover .custom-dropdown-menu{
    display: block;
}

.dropdown-item {
    display: block;
    width: 100%;
    padding: 0.7rem 1.5rem;
    clear: both;
    font-weight: 400;
    color: #00B871;
    text-align: inherit;
    white-space: nowrap;
    background-color: transparent;
    border-bottom: 1px solid #fed136;
}

.dropdown-item:hover {
    color: white;
    background-color: #02B514;
}
</style>
